import { render, staticRenderFns } from "./Home2d.html?vue&type=template&id=2e4000bf&scoped=true&"
import script from "./Home2d.vue?vue&type=script&lang=js&"
export * from "./Home2d.vue?vue&type=script&lang=js&"
import style0 from "./Home2d.scss?vue&type=style&index=0&id=2e4000bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4000bf",
  null
  
)

export default component.exports